import CompareEmailsButton from 'EmailComponents/compareEmails/CompareEmailsButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import AdditionalMoreToolsContainer from './AdditionalMoreToolsContainer';
import AffectedEmailsDropdownItem from './AffectedEmailsDropdownItem';
import BounceToolsContent from './BounceToolsContent';
import ListToolsContent from './ListToolsContent';
import ToolDescription from './ToolDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoreToolsDropdown = ({
  canSeeAdditionalMoreToolsContent,
  proOrEnt,
  onImportContactsClick,
  trackMoreToolsClick,
  preloadModals,
  onImportOptOutClick,
  onHardBounceListClick,
  onManageAllowlistingClick,
  onManageSendingLimitsClick,
  hasIlsListsWriteScope,
  hasListsWriteScope,
  hasListsViewScope,
  staticListLimitReached,
  isFree,
  isStarter,
  selectedTab,
  setComparisonToolReturnLocation,
  tracker,
  updateQueryAndPathParams
}) => {
  const showMissingListScopeTooltip = (children, checkForStaticListLimit = false) => {
    const displayToolTip = !hasListsWriteScope || !hasListsViewScope || checkForStaticListLimit && staticListLimitReached;
    const message = hasListsViewScope ? hasListsWriteScope ? 'EmailComponents.recipientsPicker.staticListLimitReachedTooltip' : 'EmailComponents.manage.moreTools.missingListWriteScope' : 'EmailComponents.manage.moreTools.missingListReadScope';
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !displayToolTip,
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      }),
      children: children
    });
  };
  const showMissingIlsListScopeTooltip = (children, checkForStaticListLimit = false) => {
    const displayToolTip = !hasIlsListsWriteScope || checkForStaticListLimit && staticListLimitReached;
    const message = hasIlsListsWriteScope ? 'EmailComponents.recipientsPicker.staticListLimitReachedTooltip' : 'EmailComponents.manage.moreTools.missingListWriteScope';
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !displayToolTip,
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      }),
      children: children
    });
  };
  const renderCompareButton = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CompareEmailsButton, {
        isFree: isFree,
        isStarter: isStarter,
        selectedTab: selectedTab,
        setComparisonToolReturnLocation: setComparisonToolReturnLocation,
        tracker: tracker,
        updateQueryAndPathParams: updateQueryAndPathParams,
        help: /*#__PURE__*/_jsx(ToolDescription, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "EmailComponents.manage.moreTools.compareEmailsDescription"
          })
        })
      }), !isFree && /*#__PURE__*/_jsx(UIDropdownDivider, {})]
    });
  };
  const renderImportToolButton = () => proOrEnt && showMissingListScopeTooltip( /*#__PURE__*/_jsxs(UILink, {
    disabled: !hasListsWriteScope,
    onClick: onImportContactsClick,
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.manage.moreTools.importContacts"
    }), /*#__PURE__*/_jsx(ToolDescription, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.manage.moreTools.importContactsDescription"
      })
    })]
  }), true);
  const renderBounceToolsDropDown = () => /*#__PURE__*/_jsx(UITooltip, {
    "data-test-id": "bounce-tools-tooltip",
    disabled: hasListsViewScope,
    placement: "right",
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.manage.moreTools.missingListReadScope"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [proOrEnt && /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(BounceToolsContent, {
        hasIlsListsWriteScope: hasIlsListsWriteScope,
        onHardBounceListCreateClick: () => onHardBounceListClick('create'),
        showMissingIlsListScopeTooltip: showMissingIlsListScopeTooltip,
        staticListLimitReached: staticListLimitReached
      })]
    })
  });
  const renderListToolsDropDown = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(ListToolsContent, {
      hasListsWriteScope: hasListsWriteScope,
      hasListsViewScope: hasListsViewScope,
      onImportOptOutClick: onImportOptOutClick,
      onManageAllowlistingClick: onManageAllowlistingClick,
      showMissingListScopeTooltip: showMissingListScopeTooltip,
      staticListLimitReached: staticListLimitReached
    })]
  });
  const renderMoreToolsDropdown = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [canSeeAdditionalMoreToolsContent && /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(AdditionalMoreToolsContainer, {
      onClick: () => {
        trackMoreToolsClick('additional-tools-dropdown');
        preloadModals();
      },
      onManageSendingLimitsClick: onManageSendingLimitsClick
    })]
  });
  return /*#__PURE__*/_jsxs(List, {
    "data-test-id": "email-tools-dropdown-list",
    children: [/*#__PURE__*/_jsx(ListItem, {
      marginBlock: "200",
      children: renderCompareButton()
    }), /*#__PURE__*/_jsx(ListItem, {
      marginBlock: "200",
      children: renderImportToolButton()
    }), /*#__PURE__*/_jsx(ListItem, {
      marginBlock: "200",
      children: renderBounceToolsDropDown()
    }), /*#__PURE__*/_jsx(ListItem, {
      marginBlock: "200",
      children: renderListToolsDropDown()
    }), /*#__PURE__*/_jsx(ListItem, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(AffectedEmailsDropdownItem, {})
    }), /*#__PURE__*/_jsx(ListItem, {
      marginBlock: "200",
      children: renderMoreToolsDropdown()
    })]
  });
};
export default MoreToolsDropdown;